import { useEffect } from 'react'
import { useToast } from '@/hooks/use-toast'

export function useToastKeyboardNavigation() {
  const { toasts, currentIndex, nextToast, previousToast, dismiss } = useToast()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Only handle if there are toasts
      if (toasts.length === 0) return

      switch (event.key) {
        case 'ArrowLeft':
          if (currentIndex > 0) {
            event.preventDefault()
            previousToast()
          }
          break
        case 'ArrowRight':
          if (currentIndex < toasts.length - 1) {
            event.preventDefault()
            nextToast()
          }
          break
        case 'Escape':
          event.preventDefault()
          dismiss(toasts[currentIndex]?.id)
          break
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [toasts, currentIndex, nextToast, previousToast, dismiss])
}
